import { DATE_FIELD_TYPE_VALUES, DEFAULT_DATE_FIELD_TYPES } from '@record-fill';
import type { DateFieldType } from '../model/form.types';

export { DATE_FIELD_TYPE_VALUES, DEFAULT_DATE_FIELD_TYPES };

export const DATE_FIELD_TYPE_OPTIONS: ReadonlyArray<{ value: DateFieldType; label: string }> = [
  { value: 'free', label: 'Livre' },
  { value: 'present', label: 'Data presente' },
  { value: 'filter', label: 'Data filtro' },
  { value: 'reference', label: 'Data referência' },
];

const MUTUALLY_EXCLUSIVE: Partial<Record<DateFieldType, DateFieldType>> = {
  free: 'present',
  present: 'free',
};

// The list is persisted in option order, never in click order: isDirty string-compares the
// serialized snapshot, so the same options in another order would light up "Salvar" on its own.
function toCanonicalOrder(types: readonly DateFieldType[]): DateFieldType[] {
  return DATE_FIELD_TYPE_VALUES.filter((type) => types.includes(type));
}

export function toggleDateFieldType(
  current: readonly DateFieldType[],
  value: DateFieldType
): DateFieldType[] {
  if (current.includes(value)) {
    if (current.length === 1) return toCanonicalOrder(current);
    return toCanonicalOrder(current.filter((type) => type !== value));
  }

  const excluded = MUTUALLY_EXCLUSIVE[value];
  return toCanonicalOrder([...current.filter((type) => type !== excluded), value]);
}
